const ValidateSingleLoadAdjustment = (adjustmentToValidate) => {
  const { amount, currency } = adjustmentToValidate;

  // if an amount is entered, it must be a valid number
  if (amount && isNaN(amount)) {
    return false;
  }

  const adjAmount = parseFloat(amount ?? 0) || 0;
  const adjCurrency = parseFloat(currency ?? 0) || 0;

  // amount is valid if it's zero - but if a currency is selected, it must be > 0
  const validAdjustment = adjAmount === 0 || (adjAmount > 0 && adjCurrency > 0);
  return validAdjustment;
};

export default ValidateSingleLoadAdjustment;
